import {Injectable} from '@angular/core';
import {Pagination} from '../../../utilities/interfaces/Pagination';
import {Flight} from '../../interfaces/Flight';
import {FlightParams} from '../../../../../services/flight/FlightParams';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {ObjectMapService} from '../../../utilities/services/object-map/object-map.service';
import {environment} from '../../../../../environments/environment';
import {CurrentUserService} from '../../../user/services/current-user/current-user.service';
import {Observable} from 'rxjs/Observable';
import {PaginationAbstractService} from '../../../utilities/services/pagination-abstract/pagination-abstract.service';
import {URLSearchParams} from '@angular/http';

@Injectable()
export class FlightService extends PaginationAbstractService<Flight, FlightParams> {

  route = 'flights';
  _shouldCache = false;
  constructor(private http: AuthHttp, objMapService: ObjectMapService,
              private currentUserService: CurrentUserService) {
    super(objMapService, 'flightParams' );
  }

  /**
   * Get all flights
   * @returns {Promise<Flight[]>}
   */
  getFlights(params?: FlightParams): Observable<Pagination<Flight>> {
    return this.getPagination(params);
  }


  protected prefetch() {
    return this.currentUserService.getCurrentUser().do((user) => {
      if (user.airport_id)
        this._params.airportId = user.airport_id;
      if (user.region_id)
        this._params.regionId = user.region_id;
      this.saveParamsToStorage();
    })
      .flatMap(() => this.http
        .get(`${environment.baseUrl}${this.route}`, {params: this.processParams(this._params)})
        .map((res) => res.json())
      );
  }

  /**
   * Get a flight by id
   * @param id
   * @returns {Promise<Flight>}
   */
  public getFlight(id: number): Promise<Flight> {
    return this.http.get(`${environment.baseUrl}${this.route}/${id}`).map((res) => res.json()).toPromise();
  }

  /**
   * Updates a flight by id
   * @param {number} id
   * @param data
   * @return {Promise<Flight>}
   */
  public update(id: number, data): Promise<Flight> {
    return this.http.put(`${environment.baseUrl}${this.route}/${id}`, data).map((res) => res.json()).toPromise();
  }

  private processParams(object: any) {
    const params = new URLSearchParams();
    for (let key in object) {
      if (Array.isArray(object[key])) {
        for (let index in object[key]) {
          params.append(`${key}[]`, JSON.stringify(object[key][index]));
        }
      } else {
        params.append(key, object[key]);
      }
    }
    return params;
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/dashboard/services/flight/flight.service.ts